// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(drawer)/_layout.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/_layout.tsx"); } },
  "./(drawer)/account.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/account.tsx"); } },
  "./(drawer)/admin.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/admin.tsx"); } },
  "./(drawer)/chat.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/chat.tsx"); } },
  "./(drawer)/consent.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/consent.tsx"); } },
  "./(drawer)/facts.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/facts.tsx"); } },
  "./(drawer)/login.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/login.tsx"); } },
  "./(drawer)/patterns.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/patterns.tsx"); } },
  "./(drawer)/settings.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/(drawer)/settings.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/_layout.tsx"); } },
  "./crisis.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/crisis.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/index.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/privacy.tsx"); } },
  "./terms.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/terms.tsx"); } },
  "./waitlist.tsx": { enumerable: true, get() { return require("/Users/frank/code/prototypes/client/app/waitlist.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;